/* =========================================================
   BR STUDIO — theme.js
   Mobile drawer + cart drawer + AJAX cart + FAQ/tab helpers.
   Vanilla JS, no dependencies. Loaded once from theme.liquid.
   ========================================================= */
(function () {
  'use strict';

  /* ---------- Mobile nav drawer ---------- */
  function initMobileNav() {
    var toggle = document.querySelector('[data-menu-toggle]');
    var drawer = document.querySelector('[data-mobile-drawer]');
    if (!toggle || !drawer) return;
    toggle.addEventListener('click', function () {
      var open = toggle.classList.toggle('open');
      drawer.classList.toggle('open', open);
      toggle.setAttribute('aria-expanded', String(open));
      document.body.style.overflow = open ? 'hidden' : '';
    });
    drawer.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', function () {
        toggle.classList.remove('open');
        drawer.classList.remove('open');
        document.body.style.overflow = '';
      });
    });
  }

  /* ---------- Cart drawer open/close ---------- */
  function openCart() {
    var d = document.getElementById('cartDrawer');
    if (d) { d.classList.add('open'); d.setAttribute('aria-hidden', 'false'); document.body.style.overflow = 'hidden'; }
  }
  function closeCart() {
    var d = document.getElementById('cartDrawer');
    if (d) { d.classList.remove('open'); d.setAttribute('aria-hidden', 'true'); document.body.style.overflow = ''; }
  }
  function initCartToggle() {
    document.querySelectorAll('[data-cart-open]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        // Only intercept if a cart drawer exists; otherwise let the link go to /cart
        if (document.getElementById('cartDrawer')) { e.preventDefault(); refreshCart().then(openCart); }
      });
    });
    document.querySelectorAll('[data-cart-close]').forEach(function (btn) {
      btn.addEventListener('click', closeCart);
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeCart(); });
  }

  /* ---------- AJAX cart ---------- */
  function fmtMoney(cents) {
    try { return (cents / 100).toLocaleString(undefined, { style: 'currency', currency: window.Shopify && Shopify.currency ? Shopify.currency.active : 'EUR' }); }
    catch (e) { return (cents / 100).toFixed(2); }
  }

  function refreshCart() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
        var sub = document.querySelector('[data-cart-subtotal]');
        if (sub) sub.textContent = fmtMoney(cart.total_price);
        return cart;
      })
      .catch(function () { /* offline / preview */ });
  }

  function initAddToCart() {
    document.querySelectorAll('form[action$="/cart/add"], form#productForm').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        // Skip AJAX if the form has a file input (needs full multipart POST handled by Shopify)
        if (form.querySelector('input[type=file]')) return;
        e.preventDefault();
        var btn = form.querySelector('[type=submit]');
        var label = btn ? btn.innerHTML : '';
        if (btn) { btn.disabled = true; btn.style.opacity = '0.6'; }
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
          body: JSON.stringify(serialize(form))
        })
          .then(function (r) { return r.json(); })
          .then(function () { return refreshCart(); })
          .then(function () { openCart(); })
          .catch(function () { form.submit(); })
          .finally(function () { if (btn) { btn.disabled = false; btn.style.opacity = ''; btn.innerHTML = label; } });
      });
    });
  }

  function serialize(form) {
    var id = form.querySelector('[name="id"]');
    var qty = form.querySelector('[name="quantity"]');
    var props = {};
    form.querySelectorAll('[name^="properties["]').forEach(function (inp) {
      var key = inp.name.replace('properties[', '').replace(']', '');
      if (inp.type === 'file') return;
      if (inp.value) props[key] = inp.value;
    });
    var payload = { id: id ? id.value : null, quantity: qty ? parseInt(qty.value, 10) : 1 };
    if (Object.keys(props).length) payload.properties = props;
    return payload;
  }

  /* ---------- Cart drawer qty steppers ---------- */
  function initCartQty() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-cart-qty]');
      if (!btn) return;
      var item = btn.closest('[data-cart-item-key]');
      if (!item) return;
      var key = item.getAttribute('data-cart-item-key');
      var span = item.querySelector('.cart-item__qty span');
      var current = parseInt(span.textContent, 10) || 1;
      var next = btn.getAttribute('data-cart-qty') === '+' ? current + 1 : current - 1;
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: Math.max(0, next) })
      })
        .then(function (r) { return r.json(); })
        .then(function () { window.location.reload(); });
    });
  }

  /* ---------- FAQ accordions (any [data-faq]) ---------- */
  function initFaq() {
    document.querySelectorAll('.faq-item button').forEach(function (btn) {
      btn.addEventListener('click', function () { btn.parentElement.classList.toggle('open'); });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initMobileNav();
    initCartToggle();
    initAddToCart();
    initCartQty();
    initFaq();
  });

  window.BRStudio = { openCart: openCart, closeCart: closeCart, refreshCart: refreshCart };
})();
